import React from 'react'
import { MdArrowBack } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { FiRefreshCcw } from "react-icons/fi";

// gradient accent for the top strip (literal classes => safe from Tailwind purge)
const ACCENT = {
    "border-brand-300": "from-brand-300 to-brand-500",
    "border-brand-400": "from-brand-400 to-brand-600",
    "border-brand-500": "from-brand-500 to-brand-700",
    "border-green-300": "from-emerald-300 to-emerald-500",
    "border-green-400": "from-emerald-400 to-emerald-600",
    "border-green-500": "from-emerald-500 to-emerald-700",
    "border-orange-300": "from-orange-300 to-amber-500",
    "border-gray-400": "from-gray-300 to-gray-400",
}

export default function Card({
    isBorder = false,
    bgColor = "bg-white",
    borderColor = "border-brand-400",
    title,
    subTitle,
    children,
    isBack = false,
    isRefresh = false,
    doRefresh,
    Icon,                 // optional icon shown before the title
    actions,             // optional node on the right of the header
    footer,              // optional node at the bottom (with a divider)
    animate = true,      // toggle entrance animation (set false inside long lists)
    className = "",       // extra classes for the card wrapper
    bodyClassName = "",  // extra classes for the body
}) {
    const navigate = useNavigate()
    const hasHeader = title || subTitle || isBack || isRefresh || Icon || actions
    const accent = ACCENT[borderColor] || "from-brand-400 to-brand-600"

    return (
        <div className={
            "group/card relative h-full flex flex-col rounded-2xl overflow-hidden border border-gray-200 "
            + "shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1 "
            + (animate ? "animate-fade-up " : "")
            + bgColor + " " + className
        }>
            {/* DoctorsCard-style gradient top accent */}
            {isBorder && <div className={"h-1.5 w-full bg-gradient-to-r " + accent} />}

            <div className="flex-1 p-4 sm:p-5">
                {hasHeader &&
                    <div className="flex items-center gap-2 mb-3">
                        {isBack &&
                            <button type="button" title='Back' aria-label="Go back"
                                className='shrink-0 grid place-items-center h-9 w-9 rounded-xl text-gray-600 hover:bg-gray-100 active:scale-95 transition'
                                onClick={() => navigate(-1)}>
                                <MdArrowBack className="text-lg" />
                            </button>
                        }

                        {Icon &&
                            <span className="shrink-0 grid place-items-center h-9 w-9 rounded-xl bg-brand-50 text-brand-600 text-lg">
                                {Icon}
                            </span>
                        }

                        <div className="flex-1 min-w-0">
                            {title && <h1 className='font-display text-lg sm:text-xl font-bold text-gray-900 leading-tight truncate'>{title}</h1>}
                            {subTitle && <p className="text-sm text-gray-500 truncate">{subTitle}</p>}
                        </div>

                        {actions && <div className="shrink-0 flex items-center gap-1">{actions}</div>}

                        {isRefresh &&
                            <button type="button" title='Refresh' aria-label="Refresh"
                                className='shrink-0 grid place-items-center h-9 w-9 rounded-xl text-brand-500 hover:bg-brand-50 active:scale-95 transition'
                                onClick={doRefresh}>
                                <FiRefreshCcw className="text-base transition-transform duration-500 group-hover/card:rotate-180" />
                            </button>
                        }
                    </div>
                }

                <div className={bodyClassName}>{children}</div>

                {footer &&
                    <div className="mt-4 pt-3 border-t border-gray-100">{footer}</div>
                }
            </div>
        </div>
    )
}